import { Link } from "react-router-dom";
import { concernMenuGroups } from "@/mocks/navigation";

export default function ConcernMegaMenu({ onNavigate }: { onNavigate: () => void }) {
  return (
    <div className="mega-in border-t border-background-300/60 bg-background-100">
      <div className="u-container py-12 lg:py-14">
        <div className="grid grid-cols-1 gap-x-10 gap-y-10 sm:grid-cols-2 lg:grid-cols-5">
          {concernMenuGroups.map((group) => (
            <div key={group.groupEn}>
              <span className="en-eyebrow text-[11px] text-secondary-700">{group.groupEn}</span>
              <span className="mt-4 block h-px w-7 bg-accent-500" />
              <ul className="mt-6 space-y-3">
                {group.items.map((item) => (
                  <li key={item.label}>
                    <Link
                      to={`${group.href}${item.hash}`}
                      onClick={onNavigate}
                      className="group flex items-center gap-3 text-[13px] text-foreground-700 transition-colors hover:text-foreground-950"
                    >
                      <span className="h-px w-3 bg-foreground-950/25 transition-all group-hover:w-5 group-hover:bg-foreground-800" />
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}